"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeNeoIdScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const auth_1 = require("@completeanatomy/auth");
const ui_1 = require("@completeanatomy/ui");
const mediaQuery_1 = require("../../cssMixins/mediaQuery");
const organisms_1 = require("../../organisms");
const lodash_noop_1 = __importDefault(require("lodash.noop"));
const styled_components_1 = __importDefault(require("styled-components"));
function FakeNeoIdScreen() {
    const isLower = (0, ui_1.useScreenBreakpoint)(mediaQuery_1.size.tablet);
    return ((0, jsx_runtime_1.jsxs)(MainScreenContainer, { children: [(0, jsx_runtime_1.jsxs)(Toolbars, { "$isHided": false, "$isMobile": isLower, "$isSearchOpen": false, children: [(0, jsx_runtime_1.jsx)(organisms_1.MainToolbar, { isSearchOpen: false, onClickDescription: lodash_noop_1.default, onClickSearch: lodash_noop_1.default, onClickLogo: lodash_noop_1.default, showScreenName: false }), (0, jsx_runtime_1.jsx)(organisms_1.SecondaryToolbar, { isSearchOpen: false, onClickDescription: lodash_noop_1.default, onClickReset: lodash_noop_1.default, onClickSearch: lodash_noop_1.default, isLabelsOpen: false, onClickLabelsButton: lodash_noop_1.default, setResetButtonPressed: () => { } })] }), (0, jsx_runtime_1.jsx)(SvgSkeletonContainer, { children: (0, jsx_runtime_1.jsx)(ui_1.SvgSkeleton, {}) }), (0, jsx_runtime_1.jsx)(auth_1.FakeNeoIDSignIn, { isLower: isLower })] }));
}
exports.FakeNeoIdScreen = FakeNeoIdScreen;
const SvgSkeletonContainer = styled_components_1.default.div `
  position: relative;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const MainScreenContainer = styled_components_1.default.div `
  font-family: 'Elsevier Sans', sans-serif;
  position: relative;
  width: 100vw;
  height: 100vh;

  background-color: ${({ theme }) => theme.grasshopper.modelBackground};
`;
const Toolbars = styled_components_1.default.div `
  pointer-events: none;
  position: absolute;
  top: 8px;
  left: ${({ $isHided, $isSearchOpen, $isMobile }) => $isHided || ($isSearchOpen && $isMobile) ? '0' : '8px'};
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: ${({ $isHided }) => $isHided ? 'calc(100vw - 8px)' : 'calc(100vw - 280px)'};
  max-width: 100%;

  & > * {
    pointer-events: auto;
  }

  z-index: 12;

  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
`;
